import React from "react";
import ActivityFormWizard from "@/components/student/ActivityFormWizard";

const StudentCreateActivityPage: React.FC = () => (
  <ActivityFormWizard mode="create" />
);

export default StudentCreateActivityPage;
